<h1 mat-dialog-title>Are you sure you want to proceed?</h1>

<div class="d-flex align-items-center">
  <mat-icon style="color: rgb(255, 208, 10); transform: scale(1.5);">warning</mat-icon>
  <p class="message">{{message}}</p>
</div>

<app-user-login [isDelete]="isDelete" [type]="type" (response)="getUserCredentials($event)"></app-user-login>




